import React from 'react';
import ImagesTab from '../../components/vendor/profile/ImagesTab';

const VendorGallery = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-4 sm:p-6">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Photo Gallery</h1>
          <p className="text-sm sm:text-base text-gray-600">Upload and manage your images for your profile and business.</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8">
          <ImagesTab />
        </div>
      </div>
    </div>
  );
};

export default VendorGallery;

